import { Component, inject, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LayoutService } from "../service/app.layout.service";
import { HeaderComponent } from '../header/header.component';
import { NgClass } from '@angular/common';
import { SidebarComponent } from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [HeaderComponent, SidebarComponent, RouterOutlet, NgClass],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})

export class LayoutComponent implements OnDestroy {

  public layoutService = inject(LayoutService);

  isSidebarOpen: boolean = false;

  constructor() {
    this.layoutService.isSidebarOpen$.subscribe((isOpen) => {
        this.isSidebarOpen = isOpen;
    });
}
    ngOnDestroy() {
    }
}
